import { NgModule } from '@angular/core';

import { MatButtonModule,
    MatMenuModule,
    MatTabsModule,
    MatToolbarModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule, 
    MatTableModule, 
    MatPaginatorModule, 
    MatSelectModule,
    MatDialogModule, 
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatExpansionModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatStepperModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatButtonToggleModule,
    MatSlideToggleModule,
    MatChipsModule,
    ErrorStateMatcher,
    ShowOnDirtyErrorStateMatcher,
    NativeDateAdapter,
    DateAdapter,
    MAT_DATE_LOCALE,
    MatProgressSpinner} from '@angular/material';
  
import { MaskDirective } from './material/mask/mask.directive';
import { OnlyNumberDirective } from './material/mask/restrict-onlynumbers.directive';

import { CurrencyMaskModule, CurrencyMaskDirective } from "ng2-currency-mask";
import { HighlightPipe } from './pipes/highlight.directive';
import { FilterVisitPipe } from './pipes/filter-visit-directive';
import { CurrencyFormatPipe } from './pipes/currency-format.directive';
import { FilterDeliveryPipe } from './pipes/filter-delivery-directive';
import { FilterCustomerTrackerPipe } from './pipes/filter-customer-tracker-directive';

import { DraggableHelperDirective } from './directives/draggable/draggable-helper.directive';
import { DraggableDirective } from './directives/draggable/draggable.directive';
import { SortableListDirective } from './directives/draggable/sortable-list.directive';
import { SortableDirective } from './directives/draggable/sortable.directive';

//import { OverlayModule } from '@angular/cdk/overlay';



@NgModule({
  imports: [
    MatButtonModule,
    MatTabsModule,
    MatMenuModule,
    MatToolbarModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatSelectModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatExpansionModule,
    MatSnackBarModule,
    MatStepperModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatButtonToggleModule,
    MatSlideToggleModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    CurrencyMaskModule
  ],
  exports: [
    MatButtonModule,
    MatTabsModule,
    MatMenuModule,
    MatToolbarModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatSelectModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatExpansionModule,
    MatSnackBarModule,
    MatStepperModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatButtonToggleModule,
    MatSlideToggleModule,
    MatChipsModule,
    MaskDirective, 
    MatProgressSpinnerModule,
    CurrencyMaskDirective, 
    OnlyNumberDirective, 
    HighlightPipe,
    FilterVisitPipe,
    FilterDeliveryPipe,
    FilterCustomerTrackerPipe,
    CurrencyFormatPipe
  ],
 
  declarations: [ 
    MaskDirective, 
    OnlyNumberDirective, 
    HighlightPipe,
    FilterVisitPipe,
    FilterDeliveryPipe,
    FilterCustomerTrackerPipe,
    CurrencyFormatPipe ],
  
})
export class MaterialModule {}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/material.module.ts